
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/build-price",
      function () {
        return require("private-next-pages/build-price/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/build-price"])
      });
    }
  